import React from 'react';
import { Transaction } from '@/types/transaction';
import { formatCurrency } from '@/utils/formatters';

interface TransactionFeeDetailsProps {
  transaction: Transaction;
}

const TransactionFeeDetails: React.FC<TransactionFeeDetailsProps> = ({ transaction }) => {
  const grossAmount = transaction.gross_amount_cents 
    ? transaction.gross_amount_cents / 100
    : transaction.amount 
      ? (typeof transaction.amount === 'number' && transaction.amount > 100 ? transaction.amount / 100 : transaction.amount) 
      : 0;
  
  // Calculate application (platform) fee in dollars
  const applicationFeeAmount = transaction.application_fee_cents
    ? transaction.application_fee_cents / 100
    : 0;
  
  // Calculate net amount in dollars
  const netAmount = transaction.net_amount_cents
    ? transaction.net_amount_cents / 100
    : transaction.net_received_cents
      ? transaction.net_received_cents / 100
      : null;
    
  // Calculate stripe fee in dollars
  let stripeFeeAmount = 0;
  
  if (transaction.stripe_fee_cents !== null && transaction.stripe_fee_cents !== undefined && transaction.stripe_fee_cents > 0) {
    stripeFeeAmount = transaction.stripe_fee_cents / 100;
  } else if (netAmount !== null && grossAmount > 0 && netAmount < grossAmount) {
    const calculatedStripeFee = grossAmount - netAmount - applicationFeeAmount;
    if (calculatedStripeFee > 0) {
      stripeFeeAmount = calculatedStripeFee;
    } else {
      console.warn('[TransactionFeeDetails] Calculated stripe fee is 0 or negative. Gross:', grossAmount, 'Net:', netAmount, 'App Fee:', applicationFeeAmount);
    }
  } else {
    if (grossAmount > 0) {
      const estimatedFee = (grossAmount * 0.029) + 0.30;
      stripeFeeAmount = estimatedFee;
    }
  }
  
  const finalNetAmount = netAmount !== null && netAmount < grossAmount
    ? netAmount 
    : (grossAmount - stripeFeeAmount - applicationFeeAmount);
  
  return (
    <div className="space-y-2">
      <h3 className="text-sm font-medium text-muted-foreground mb-1">Fee Breakdown</h3>
      
      <div className="flex justify-between text-sm">
        <span>Gross Amount:</span>
        <span>
         {formatCurrency(grossAmount)}
        </span>
      </div>
      
      <div className="flex justify-between text-sm">
        <span>Stripe Fee:</span>
        <span className="text-red-500">
          -{formatCurrency(stripeFeeAmount)}
        </span>
      </div>
      
      {applicationFeeAmount > 0 && (
        <div className="flex justify-between text-sm">
          <span>Platform Fee:</span>
          <span className="text-red-500">
            -{formatCurrency(applicationFeeAmount)}
          </span>
        </div>
      )}
      
      <div className="flex justify-between font-medium pt-2 border-t">
        <span>Net Amount:</span>
        <span>{formatCurrency(finalNetAmount)}</span>
      </div>
    </div>
  );
};

export default TransactionFeeDetails;